import './Game.scss';
import { RootState } from '../store';
import { useAppSelector } from '../redux'
import { GamePlayState } from "../Enums/GameEnums";
import HealthBar from "./HealthBar";
import BlackjackCards from './BlackjackCards';
import { MONSTER_CLASSES } from '../Enums/Attributes';
import SpritesheetAsset from '../Components/SpritesheetAsset';
import MonsterAvatar from './MonsterAvatar';
import Attributes from './Attributes';

function MonsterBlackjack() {
  const gameState = useAppSelector((state: RootState) => state.game)
  const engineState = gameState.engineState
  const monster = MONSTER_CLASSES.find(x => x.name === gameState.monster.name);
  const gamePlayState = gameState.gamePlayState

  return (
    <div className="monster-blackjack">

      <div className="monster-blackjack_data">
        <Attributes
          att={gameState.monster.attributes.att}
          def={gameState.monster.attributes.def}
          pierce={gameState.monster.attributes.pierce}
        />

        <HealthBar type="monster" currentHP={gameState.monster.attributes.currentHp} maxHP={gameState.monster.attributes.maxHp} />


        <MonsterAvatar />
      </div>


      {gamePlayState !== GamePlayState.BETTING && // corner case, when returning to ongoing game
        <BlackjackCards isMuted={gameState.isMuted} cards={engineState?.dealerCards} label={engineState?.dealerValue} owner={"monster"} />
      }

    </div>
  );
}

export default MonsterBlackjack;
